import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { isFeatureEnabled } from 'owa-feature-flags';
import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import type { MailboxInfo } from 'owa-client-types';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';
import { UnifiedInboxSupportedFolders } from 'owa-folders-constants';

export function getFoldersToShowFirst(
    mailboxInfo: MailboxInfo | undefined
): DistinguishedFolderIdName[] {
    if (mailboxInfo && isUnifiedInboxMailboxInfo(mailboxInfo)) {
        // If mailboxInfo is a Unified Inbox, return the supported folders for Unified Inbox
        // in the same order that is defined
        return UnifiedInboxSupportedFolders;
    }

    const firstFolders: DistinguishedFolderIdName[] = !isConsumer(
        undefined /*smtpAddress*/,
        mailboxInfo
    )
        ? ['inbox', 'drafts', 'sentitems', 'scheduled', 'deleteditems', 'junkemail', 'archive']
        : ['inbox', 'junkemail', 'drafts', 'sentitems', 'scheduled', 'deleteditems', 'archive'];

    if (isFeatureEnabled('notes-folder-view')) {
        firstFolders.push('notes');
    }

    return firstFolders;
}
